import { render, staticRenderFns } from "./ConsultingTopicPicture.vue?vue&type=template&id=67ac90fc&scoped=true&"
import script from "./ConsultingTopicPicture.vue?vue&type=script&lang=js&"
export * from "./ConsultingTopicPicture.vue?vue&type=script&lang=js&"
import style0 from "./ConsultingTopicPicture.vue?vue&type=style&index=0&id=67ac90fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ac90fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VIcon,VImg,VLayout,VProgressCircular})
